module.exports = __webpack_public_path__ + "static/stacheldraht_gr.68cb4e0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Stacheldraht/stacheldraht_gr.png
// module id = 441
// module chunks = 35783957827783